import { isEnabled } from 'features/helpers';
import { FEATURES } from './features';

const fflipConfig = {
  criteria: [],
  features: [
    {
      id: FEATURES.BESOIN_DAIDE,
      enabled: isEnabled(process.env.REACT_APP_FFLIP_BESOIN_DAIDE),
    },
    {
      id: FEATURES.UNIVERSE_AMC,
      enabled: isEnabled(process.env.REACT_APP_FFLIP_UNIVERSE_AMC),
    },
    {
      id: FEATURES.UNIVERSE_ASI,
      enabled: isEnabled(process.env.REACT_APP_FFLIP_UNIVERSE_ASI),
    },
    {
      id: FEATURES.ACAPS,
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ACAPS),
    },
    {
      id: FEATURES.NO_ACAPS,
      enabled: !isEnabled(process.env.REACT_APP_FFLIP_ACAPS),
    },
  ],
  reload: 60,
};

export default fflipConfig;
